"use strict";

exports.__esModule = true;
exports.default = void 0;

var _urlParse = _interopRequireDefault(require("url-parse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  /**
   * 合并url&querystring
   * @type {String} url 链接
   * @type {Object} data queryString参数
   * @type {Boolean} cache 是否经过本地缓存
   */
  mixUrl: function mixUrl(url, data, cache) {
    if (data === void 0) {
      data = {};
    }

    if (cache === void 0) {
      cache = false;
    }

    url = new _urlParse.default(url);
    var query = url.query;

    if (!cache) {
      data._ = Date.now();
    }

    Object.keys(data).forEach(function (key) {
      var seperator = query ? '&' : '?';
      query += "" + seperator + key + "=" + encodeURIComponent(data[key]);
    });
    url.set('query', query);
    return url.href;
  },

  /**
   * 更新querystring
   * @type {String} url 链接
   * @type {Object} data queryString参数
   */
  updateQueryString: function updateQueryString(url, data) {
    if (data === void 0) {
      data = {};
    }

    url = new _urlParse.default(url, true);
    var query = url.query;
    Object.assign(query, data);
    url.set('query', query);
    return url.href;
  },

  /**
   * query object转成querystring
   * @param {object} queryO query object
   */
  getQueryString: function getQueryString(queryO) {
    var query = queryO;
    var result = [];

    if (query) {
      Object.keys(query).forEach(function (key) {
        result.push(key + "=" + query[key]);
      });
    }

    return result.join('&');
  },

  /**
   * 序列化
   * @type {String} o 对象
   */
  serialize: function serialize(o) {
    if (o === void 0) {
      o = {};
    }

    var result = '';
    Object.keys(o).forEach(function (key) {
      var val = o[key];
      val = typeof o[key] === 'object' ? JSON.stringify(val) : val;
      result += "&" + key + "=" + val;
    });
    return result.slice(1);
  },

  /**
   * 针对特殊字符的情况，对所有字符串进行encode操作
   */
  encode: function encode(data) {
    var _this = this;

    var identify = Object.prototype.toString.call(data);
    var result;

    if (identify === '[object Array]') {
      result = [];
      Object.keys(data).forEach(function (key) {
        result.push(_this.encode(data[key]));
      });
    } else if (identify === '[object Object]') {
      result = {};
      Object.keys(data).forEach(function (key) {
        result[key] = _this.encode(data[key]);
      });
    } else if (typeof data === 'string') {
      result = window.encodeURIComponent(data);
    } else {
      result = data;
    }

    return result;
  },

  /**
   * 加载js文件
   * @param {string} url
   * @param {function} callback
   */
  loadjs: function loadjs(url, callback) {
    var script = document.createElement('script');

    callback = callback || function () {};

    script.type = 'text/javascript';
    script.crossorigin = 'anonymous';

    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  },

  /**
   * 解析url
   * @param {string} url
   */
  urlParse: function urlParse(url) {
    return new _urlParse.default(url);
  },

  /**
   * 获取query对象
   * @param {string} url
   */
  getQueryObject: function getQueryObject(url) {
    var params = {};
    url = new _urlParse.default(url);
    var _url = url,
        query = _url.query;

    if (query) {
      query = query.substr(1).split('&');
    }

    query = query || [];

    for (var i = 0; i < query.length; i++) {
      params[query[i].split('=')[0]] = unescape(query[i].split('=')[1]);
    }

    return params;
  },

  /**
   * 修改url querystring参数
   * @param {object} params url参数
   * @param {string} params.baseUrl base url
   * @param {string} params.targetUrl target url
   * @param {array} params.defaultQueryList 默认需要往下带的参数
   * @param {array} params.removedQueryList 删除的参数
   * @param {object} params.addedQuery 新增的参数
   * @returns {string} last url
   */
  changeUrlQuery: function changeUrlQuery(_ref) {
    var _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === void 0 ? window.location.href : _ref$baseUrl,
        targetUrl = _ref.targetUrl,
        _ref$defaultQueryList = _ref.defaultQueryList,
        defaultQueryList = _ref$defaultQueryList === void 0 ? [] : _ref$defaultQueryList,
        _ref$removedQueryList = _ref.removedQueryList,
        removedQueryList = _ref$removedQueryList === void 0 ? [] : _ref$removedQueryList,
        _ref$addedQuery = _ref.addedQuery,
        addedQuery = _ref$addedQuery === void 0 ? {} : _ref$addedQuery;
    var parsedUrl = new _urlParse.default(targetUrl);
    var queryO = this.getQueryObject(targetUrl);

    for (var _iterator = defaultQueryList, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref2 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref2 = _i.value;
      }

      var queryItem = _ref2;
      var baseQueryO = this.getQueryObject(baseUrl);

      if (!queryO.hasOwnProperty(queryItem) && baseQueryO.hasOwnProperty(queryItem)) {
        var _Object$assign;

        Object.assign(queryO, (_Object$assign = {}, _Object$assign[queryItem] = baseQueryO[queryItem], _Object$assign));
      }
    }

    Object.assign(queryO, addedQuery);

    for (var _iterator2 = removedQueryList, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var _queryItem = _ref3;

      if (queryO.hasOwnProperty(_queryItem)) {
        delete queryO[_queryItem];
      }
    }

    parsedUrl.set('query', this.getQueryString(queryO));
    return parsedUrl.toString();
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@lianjia/helper/url.js
// module id = 168
// module chunks = 2 3